<template>
  <div id="defaultId1" class="company_detail IE_root">
    <div id="g2ede8" class="operations-content">
      <div class="operations-box pb20">
        <div  v-show="DetailCompanyShow">
          <div class="operations-box-head mb10">
            <div class="operations-box-head operations-box-head-left">
              <div class="operations-box-left">
                <div class="operations-content-head">
                  <div class="perations-content-left">
                    <span
                      :class="
                        activeIEports == 'Imports'
                          ? 'perations-button perations-button-active'
                          : 'perations-button'
                      "
                      @click="ceckIEports('Imports')"
                    >
                      {{ $t("ImportExport.Imports") }}</span
                    >
                    <span
                      @click="ceckIEports('Exports')"
                      :class="
                        activeIEports == 'Exports'
                          ? 'perations-button perations-button-active'
                          : 'perations-button'
                      "
                      >{{ $t("ImportExport.Exports") }}</span
                    >
                  </div>
                </div>
                <div>
                  <el-table
                    :data="tableData"
                    style="width: 100%"
                    :show-header="false"
                    empty-text="No Data"
                  >
                    <el-table-column
                      prop="Top"
                      label="Top"
                      :width="tableColumnWidth.colum1"
                    >
                      <template slot-scope="scope">
                        <span
                          :class="
                            scope.$index > 2 ? 'table-content' : 'table-content '
                          "
                          >{{ scope.$index + 1 }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="Country"
                      label="Country"
                      :width="tableColumnWidth.colum2"
                    >
                      <template slot-scope="scope">
                        <!-- @click="handleCommand('Proportion of host country', scope.row)" -->
                        <!-- table-content-color -->
                        <span
                          :class="
                            scope.$index > 2 ? 'table-content' : 'table-content '
                          "
                          >{{ scope.row.valueEn }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="Progress"
                      label=""
                      :width="tableColumnWidth.colum3"
                    >
                      <template slot-scope="scope">
                        <el-progress
                          :text-inside="true"
                          :stroke-width="22"
                          define-back-color="#DDDDDD"
                          :show-text="true"
                          :percentage="
                            Number(scope.row.percentage.replace(/%/g, '').trim())
                          "
                          :color="
                            customColorMethod(scope.row.percentage, scope.$index)
                          "
                        ></el-progress>
                      </template>
                    </el-table-column>
                    <el-table-column prop="percentage" label="percentage">
                      <template slot-scope="scope">
                        <span class="table-content">{{
                          scope.row.percentage
                        }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="operations-center-center">
                <div class="operations-center-select">
                  <span class="bottom-titletwo detail_title_20">
                    {{ $t("ImportExport.TradeVolume") }}</span
                  >
                  <div class="perations-content-left">
                  <span
                    :class="
                      value == '1'
                        ? 'perations-button perations-button-active'
                        : 'perations-button'
                    "
                    @click="ChangesTrade('1')"
                  >
                    {{ $t("ImportExport.Imports") }}</span
                  >
                  <span
                    @click="ChangesTrade('2')"
                    :class="
                      value == '2'
                        ? 'perations-button perations-button-active'
                        : 'perations-button'
                    "
                    >{{ $t("ImportExport.Exports") }}</span
                  >
                </div>
                  <!-- <el-select
                    ref="upSelect3"
                    v-click-outside="clickOutSide3"
                    class="IE_root_el_select IE_first_box_select"
                    popper-class="common_select"
                    v-model="value"
                    placeholder=""
                    @change="ChangesTrade"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select> -->
                </div>
                <div class="echarts">
                  <div
                    ref="SupplyChainEchart"
                    class="IE_top_echarts"
                    style="width: 100%"
                  ></div>
                </div>
              </div>
            </div>
            <div class="operations-box-left operations-box-right">
              <div class="operations-content-head operations-right-head">
                <span>{{ $t("ImportExport.ImportShipments") }}</span>
                <span>{{ sixColumns.importTransactions | FormatNum }}</span>
              </div>
              <div class="operations-content-head operations-right-head">
                <span>{{ $t("ImportExport.ExportShipments") }}</span>
                <span>{{ sixColumns.exportTransactions | FormatNum }}</span>
              </div>
              <div class="operations-content-head operations-right-head">
                <span>{{ $t("ImportExport.ImportCountries") }}</span>
                <span>{{ sixColumns.importCountries }}</span>
              </div>
              <div class="operations-content-head operations-right-head">
                <span>{{ $t("ImportExport.ExportCountries") }}</span>
                <span>{{ sixColumns.exportCountries }}</span>
              </div>
              <div class="operations-content-head operations-right-head">
                <span>{{ $t("ImportExport.ImportVolume") }}</span>
                <span>{{ sixColumns.importValues | FormatNum }}</span>
              </div>
              <div class="operations-content-head operations-right-head">
                <span>{{ $t("ImportExport.ExportVolume") }}</span>
                <span>{{ sixColumns.exportValues | FormatNum }}</span>
              </div>
            </div>
          </div>
          <div
            :class="['mb10', powerArr[1]?.hasPrivilege ? '' : 'vaguesuo']"
            @click="
              powerArr[1]?.hasPrivilege
                ? ''
                : $bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            "
          >
            <div
              :class="
                powerArr[1]?.hasPrivilege ? 'operations-box-center' : 'vague'
              "
            >
              <h3 id="gf7b16" class="operations-center-head operations_center_changeBtn">
                <div class="perations-content-left operations_center_changeBtn_content">
                  <span
                    :class="
                      value2 == 'Shipments'
                        ? 'perations-button perations-button-active  operations_center_changeBtn_content_text'
                        : 'perations-button  operations_center_changeBtn_content_text'
                    "
                    @click="centerEcharts('Shipments')"
                  >
                    {{ $t("ImportExport.Shipments2") }}</span
                  >
                  <span
                    @click="centerEcharts('value')"
                    :class="
                      value2 == 'value'
                        ? 'perations-button perations-button-active operations_center_changeBtn_content_text'
                        : 'perations-button operations_center_changeBtn_content_text'
                    "
                    >{{ $t("ImportExport.value2") }}</span
                  >
                </div>

                <!-- <el-select
                  ref="upSelect4"
                  v-click-outside="clickOutSide4"
                  class="IE_root_el_select IE_second_box_top_select"
                  popper-class="common_select"
                  v-model="value2"
                  placeholder=""
                  @change="centerEcharts"
                >
                  <el-option
                    v-for="item in Centeroptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> -->
              </h3>
              <div class="operations-box-head IE_second_box">
                <div class="operations-box-center-left">
                  <div class="operations-box-center-headr operations-box-head">
                    <!-- {{ $t("ImportExport.Imports") }} -->
                    <!-- Top {{ ImpirtShow }} -->
                    {{ $t(`ImportExport.${ImpirtShow}`) }}
                    <span
                      class="callBack"
                      v-if="ImpirtShow != 'Suppliers'"
                      @click="callBack()"
                      >Back</span
                    >
                  </div>
                  <!-- <h3 class="TopPorts">Top {{ ImpirtShow }}</h3> -->
                  <h5 class="Byshipments">{{ $t(`ImportExport.${value2}`) }}</h5>
                  <!-- By Number of {{ value2 }} -->
                  <div class="Byshipments-table" v-if="ImpirtShow == 'Suppliers'">
                    <div
                      class="line_step"
                      v-for="(item, index) in TopCustomers"
                      :key="index"
                    >
                      <div class="txt flex_center_between_box">
                        <span
                          class="line_title"
                          @click="gotoProduct(item, 'Product')"
                          >{{ item.valueEn }}</span
                        >
                        <span class="blue_num" style="color: #8497ab">{{
                          item.dateCount | FormatNum
                        }}</span>
                      </div>
                      <el-progress
                        color="#1290C9"
                        :stroke-width="10"
                        :show-text="false"
                        define-back-color="#DDDDDD"
                        :percentage="getProgress(item)"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="Byshipments-table" v-if="ImpirtShow == 'Product'">
                    <div
                      class="line_step"
                      v-for="(item, index) in TopPortsImportProduct"
                      :key="index"
                    >
                      <div class="txt flex_center_between_box">
                        <span
                          class="line_title"
                          @click="gotoProductPorts(item.code, 'Ports')"
                          >{{ item.valueEn }}</span
                        >
                        <span class="blue_num" style="color: #8497ab">{{
                          item.dateCount | FormatNum
                        }}</span>
                      </div>
                      <el-progress
                        color="#1290C9"
                        :stroke-width="10"
                        :show-text="false"
                        define-back-color="#DDDDDD"
                        :percentage="getProgress(item)"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="Byshipments-table" v-if="ImpirtShow == 'Ports'">
                    <div
                      class="line_step"
                      v-for="(item, index) in TopPortsImportPorts"
                      :key="index"
                    >
                      <div class="txt flex_center_between_box">
                        <span
                          class="line_title"
                          style="text-decoration-line: none"
                          >{{ item.valueEn }}</span
                        >
                        <span class="blue_num" style="color: #8497ab">{{
                          item.dateCount | FormatNum
                        }}</span>
                      </div>
                      <el-progress
                        color="#1290C9"
                        :stroke-width="10"
                        :show-text="false"
                        define-back-color="#DDDDDD"
                        :percentage="getProgress(item)"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="flex_center_between_box">
                    <el-select
                      ref="upSelect5"
                      class="IE_root_el_select IE_second_box_content_select"
                      v-click-outside="clickOutSide5"
                      popper-class="common_select"
                      v-model="imporetvalue"
                      placeholder=""
                      @change="Centeroptionschange(1)"
                    >
                      <el-option
                        v-for="item in TopCustomers"
                        :key="item.valueEn"
                        :label="item.valueEn"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="echartsimport">
                    <div
                      ref="ImportEchart"
                      style="width: 100%; height: 422px"
                    ></div>
                  </div>
                </div>
                <div
                  class="operations-box-center-left operations-box-center-right"
                >
                  <div class="operations-box-center-headr operations-box-head">
                    <!-- {{ $t("ImportExport.Exports") }} -->
                    <!-- Top {{ ExportShow }} -->
                     {{ $t(`ImportExport.${ExportShow}`) }}
                    <span
                      class="callBack"
                      v-if="ExportShow != 'Buyers'"
                      @click="callBacktwo()"
                      >Back</span
                    >
                  </div>
                  <!-- <h3 class="TopPorts">Top {{ ExportShow }}</h3> -->
                  <h5 class="Byshipments">{{ $t(`ImportExport.${value2}`) }}</h5>
                  <div class="Byshipments-table" v-if="ExportShow == 'Buyers'">
                    <div
                      class="line_step"
                      v-for="(item, index) in TopSuppliers"
                      :key="index"
                    >
                      <div class="txt flex_center_between_box">
                        <span
                          class="line_title"
                          @click="gotoProducttwo(item, 'Product')"
                          >{{ item.valueEn }}</span
                        >
                        <span class="blue_num" style="color: #8497ab">{{
                          item.dateCount | FormatNum
                        }}</span>
                      </div>
                      <el-progress
                        color="#1290C9"
                        :stroke-width="10"
                        :show-text="false"
                        define-back-color="#DDDDDD"
                        :percentage="getProgress(item)"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="Byshipments-table" v-if="ExportShow == 'Product'">
                    <div
                      class="line_step"
                      v-for="(item, index) in TopPortsExportProduct"
                      :key="index"
                    >
                      <div class="txt flex_center_between_box">
                        <span
                          class="line_title"
                          @click="gotoProductPortstwo(item.code, 'Ports')"
                          >{{ item.valueEn }}</span
                        >
                        <span class="blue_num" style="color: #8497ab">{{
                          item.dateCount | FormatNum
                        }}</span>
                      </div>
                      <el-progress
                        color="#1290C9"
                        :stroke-width="10"
                        :show-text="false"
                        define-back-color="#DDDDDD"
                        :percentage="getProgress(item)"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="Byshipments-table" v-if="ExportShow == 'Ports'">
                    <div
                      class="line_step"
                      v-for="(item, index) in TopPortsExportPorts"
                      :key="index"
                    >
                      <div class="txt flex_center_between_box">
                        <span
                          class="line_title"
                          style="text-decoration-line: none"
                          >{{ item.valueEn }}</span
                        >
                        <span class="blue_num" style="color: #8497ab">{{
                          item.dateCount | FormatNum
                        }}</span>
                      </div>
                      <el-progress
                        color="#1290C9"
                        :stroke-width="10"
                        :show-text="false"
                        define-back-color="#DDDDDD"
                        :percentage="getProgress(item)"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="flex_center_between_box">
                    <el-select
                      ref="upSelect2"
                      class="IE_root_el_select IE_second_box_content_select"
                      v-click-outside="clickOutSide2"
                      popper-class="common_select"
                      v-model="exportvalue"
                      placeholder=""
                      @change="Centeroptionschange(2)"
                    >
                      <el-option
                        v-for="item in TopSuppliers"
                        :key="item.value"
                        :label="item.valueEn"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="echartsimport">
                    <div
                      ref="ExportEchart"
                      style="width: 100%; height: 422px"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="IE_bottom_box">
            <div>
              <h3 id="gf7b16" class="IE_bottom_box_head">
                <span class="bottom-title">{{
                  $t("ImportExport.ImportsExportsRecords")
                }}</span>
                <div class="perations-content-left">
                  <span
                    :class="
                      tblHeaderActiveIEports == '1'
                        ? 'perations-button perations-button-active'
                        : 'perations-button'
                    "
                    @click="changeImportExportType('1')"
                  >
                    {{ $t("ImportExport.Imports") }}</span
                  >
                  <span
                    @click="changeImportExportType('2')"
                    :class="
                      tblHeaderActiveIEports == '2'
                        ? 'perations-button perations-button-active'
                        : 'perations-button'
                    "
                    >{{ $t("ImportExport.Exports") }}</span
                  >
                </div>
                <!-- <el-select
                  ref="upSelect1"
                  class="IE_root_el_select IE_third_box_top_select"
                  v-click-outside="clickOutSide1"
                  popper-class="common_select"
                  v-model="importsandexports"
                  placeholder=""
                  @change="changeImportExportType"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> -->
              </h3>
              <el-table
                :data="
                  ImporttableData
                "
                class="IE_bottom_box_table"
                :key="key"
                empty-text="No Data"
              >
                <el-table-column
                  prop="Date"
                  :label="$t('ImportExport.Date')"
                  show-overflow-tooltip
                  align="left"
                >
                <template slot="header" slot-scope="scope">
                  <div @click="filterOptions.date.length > 1 && toggleHeaderDropdown('Date')">
                    <template v-if="!showHeaderDateDropdown">
                      <span>{{ $t('ImportExport.Date') }}</span>
                      <i class="dropdown-icon" v-if="filterOptions.date.length > 1"></i>
                    </template>
                    <div v-else>
                      <el-select 
                        v-model="selectedFilters.date" 
                        @change="applyFilter"
                        size="mini"
                        class="IE_bottom_box_table_header_select"
                        clearable
                      >
                        <el-option style="display: none;" :label="$t('ImportExport.Selectdate')" value=""></el-option>
                        <el-option label="All" value="-1"></el-option>
                        <el-option 
                          v-for="item in filterOptions.date" 
                          :key="item.code" 
                          :label="item.valueEn" 
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.date }}</span>
                </template>
                </el-table-column>
                <el-table-column
                  prop="products"
                  :label="$t('ImportExport.Product')"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span class="table-content">{{ scope.row.products }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="hsCode"
                  :label="$t('ImportExport.HSCode')"
                  show-overflow-tooltip
                >
                  <!-- 表头切换 slot="header" slot-scope="scope"-->
                  <template slot="header" slot-scope="scope">
                    <span class="table_add" @click="showSearchHscode()">
                      <el-input
                        v-if="isshowSearchHscode"
                        autocomplete="off"
                        v-model="SearchHscode"
                        type="text"
                        class="IE_bottom_box_table_search_input"
                        :placeholder="$t('ImportExport.SearchHSCode')"
                        @change="applyFilter"
                        @blur="seachHS"
                        clearable
                      >
                        <svg
                          slot="suffix"
                          t="1718683815723"
                          class="icon IE_bottom_box_table_search"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7262"
                          v-if="SearchHscode.length == 0"
                        >
                          <path
                            d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                            fill="#1290C9"
                            p-id="7263"
                          ></path>
                        </svg>
                      </el-input>
                      <span v-else>
                        <span class="font_bold">{{
                          $t("ImportExport.HSCode")
                        }}</span>
                        <svg
                          t="1718683815723"
                          class="icon ml5 IE_bottom_box_table_search"
                          @click="searchPersonByName()"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7262"
                          width="2.14rem"
                          height="2.14rem"
                        >
                          <path
                            d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                            fill="#1290C9"
                            p-id="7263"
                          ></path>
                        </svg>
                      </span>
                    </span>
                  </template>
                  <template slot-scope="scope">
                    <span class="table-content">{{ scope.row.hsCode }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="BuyerNames"
                  class-name="company company_link company_link_tooltip_normal"
                  :label="$t('ImportExport.BuyerName')"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span
                      class="table-content company_link"
                      @click="setid(scope.row, 'Buyer')"
                      >{{ scope.row.buyerEn }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="exportCountryEn"
                  :label="$t('ImportExport.Destination')"
                  show-overflow-tooltip
                >
                  <template slot="header" slot-scope="scope">
                    <div @click="filterOptions?.destination?.length > 1 && toggleHeaderDropdown('Destination')">
                      <template v-if="!showHeaderDestinationDropdown">
                        <span>{{ $t('ImportExport.Destination') }}</span>
                        <i v-if="filterOptions?.destination?.length > 1" class="dropdown-icon" />
                      </template>
                      <div v-else>
                        <el-select 
                          v-model="selectedFilters.destination" 
                          @change="applyFilter"
                          size="mini"
                          class="IE_bottom_box_table_header_select"
                          clearable
                        >
                          <el-option style="display: none;" label="Select Destination" value=""></el-option>
                          <el-option label="All" value="-1"></el-option>
                          <el-option 
                            v-for="item in filterOptions.destination" 
                            :key="item.code" 
                            :label="item.valueEn" 
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <span class="table-content">{{
                      scope.row.importCountryEn
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="suppliersEn"
                  class-name="company company_link company_link_tooltip_normal"
                  :label="$t('ImportExport.SupplierName')"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span
                      class="table-content company_link"
                      @click="setid(scope.row, 'Supplier')"
                      >{{ scope.row.suppliersEn }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Origin"
                  :label="$t('ImportExport.Origin')"
                  show-overflow-tooltip
                  align="left"
                >
                  <template slot="header" slot-scope="scope">
                    <div @click="filterOptions?.origin?.length > 1 && toggleHeaderDropdown('Origin')">
                      <template v-if="!showHeaderOriginDropdown">
                        <span>{{ $t('ImportExport.Origin') }}</span>
                        <i v-if="filterOptions?.origin?.length > 1" class="dropdown-icon" />
                      </template>
                      <div v-else>
                        <el-select 
                          v-model="selectedFilters.origin" 
                          @change="applyFilter"
                          size="mini"
                          class="IE_bottom_box_table_header_select"
                          clearable
                        >
                          <el-option style="display: none;" label="Select Origin" value=""></el-option>
                          <el-option label="All" value="-1"></el-option>
                          <el-option 
                            v-for="item in filterOptions.origin" 
                            :key="item.code" 
                            :label="item.valueEn" 
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <span class="table-content">{{
                      scope.row.exportCountryEn
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Amount"
                  :label="$t('ImportExport.Amount')"
                  align="right"
                >
                  <template slot-scope="scope">
                    <span class="table-content">{{
                      scope.row.amount | FormatNum
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Details"
                  :label="$t('ImportExport.Details')"
                  align="center"
                >
                  <template slot-scope="scope">
                    <svg
                      t="1718681277467"
                      class="icon IE_bottom_box_table_tbody_icon"
                      @click="gotoExportDetail(scope.row.dataId)"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="6986"
                    >
                      <path
                        d="M867.2 995.7H159.8c-51.7 0-93.8-42.1-93.8-93.8V139.6c0-51.7 42.1-93.8 93.8-93.8h707.3c51.7 0 93.8 42.1 93.8 93.8v762.3c0.1 51.8-42 93.8-93.7 93.8zM159.8 85.8c-29.7 0-53.8 24.1-53.8 53.8v762.3c0 29.7 24.1 53.8 53.8 53.8h707.3c29.7 0 53.8-24.1 53.8-53.8V139.6c0-29.7-24.1-53.8-53.8-53.8H159.8z"
                        fill="#1290C9"
                        p-id="6987"
                      ></path>
                      <path
                        d="M753.2 381.2H273.8c-11 0-20-9-20-20s9-20 20-20h479.3c11 0 20 9 20 20s-8.9 20-19.9 20zM521.9 540.8H273.8c-11 0-20-9-20-20s9-20 20-20h248.1c11 0 20 9 20 20s-8.9 20-20 20zM644.9 700.4H273.8c-11 0-20-9-20-20s9-20 20-20h371.1c11 0 20 9 20 20s-8.9 20-20 20z"
                        fill="#1290C9"
                        p-id="6988"
                      ></path>
                    </svg>
                    <!-- <span class="table-content">{{ scope.row.Details }}</span> -->
                  </template>
                </el-table-column>
              </el-table>
              <div class="page_i_box">
                <Page
                  :totalFont="true"
                  :total="page.total"
                  :pageSize.sync="page.pageSize"
                  :currentPage.sync="page.pageNo"
                  @onPageChange="onPageChangeList"
                ></Page>
                <div class="search_rsult_txt line_2">
                  {{ page.pageNo }}-{{ page.pageSize }} of over
                  <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total | FilterNum }}&nbsp;</span> results for "{{
                    $t("ImportExport.ImportsExportsRecords")
                  }}"
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <importDetailCompany :detailsiD="importDetailCompanyDetailsiD" :fatherMethod="ShowDetailCompany"></importDetailCompany>
        </div>

      </div>
      <!-- <PermissionDialog></PermissionDialog> -->
      <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    </div>
  </div>
</template>
<script>
import importDetailCompany from "./ImportDetail.vue";
import { formatNum } from "@/views/company/details/Background/utils";

import {
  getImportorExportTransaction,
  getImportExportALl,
  getImportorExportRankBySC,
  getImportOrExportProductTrade,
  showImportorExportForSCRanks,
  getImportOrExportTradeByContinent,
  getPartPrivilege,
  searchFilterConditions,
} from "@/api/companyApi";
import PermissionDialog from "@/components/power/PermissionDialog.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import Page from "@/components/page/index.vue";
export default {
  name: "",
  props: {},

  components: {
    PermissionDialog,
    ReLogin,
    Page,
    importDetailCompany,

  },
  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getImportExportALl();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      reLoginVis: false,
      powerArr: [],
      importsandexports: "1",
      ImpirtShow: "Suppliers",
      ExportShow: "Buyers",
      activeIEports: "Imports",
      sixColumns: {},
      selectcouny: "Proportion of host country",
      ImporttableData: [],

      tableData: [],
      key: 0,
      topImportContinentList: [],
      topImportCountriesList: [],
      topExportContinentList: [],
      topExportCountriesList: [],
      importCountryTrendMap: [],
      exportCountryTrendMap: [],
      TopCustomers: [],
      TopProductCustomers: [],
      TopPortsImportProduct: [],
      TopPortsExportProduct: [],
      TopPortsImportPorts: [],
      TopPortsExportPorts: [],
      TopSuppliers: [],
      value: "1",
      value2: "Shipments",
      isshowSearchHscode: false,
      SearchHscode: "",
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      supplierId: "",
      imporetvalue: "",
      exportvalue: "",
      importTrendListEcharts: [],
      importGrowthRateTrendList: [],
      exportGrowthRateTrendList: [],
      exportTrendListEcharts: [],
      echartsSever: [],
      echartsSeveryear: [],
      importTrendMap: [],
      exportTrendMap: [],
      imporetoption: [
        {
          value: "Ford India Pvt. Ltd.",
          label: "Ford India Pvt. Ltd.",
        },
        {
          value: "Apple Inc",
          label: "Apple Inc",
        },
      ],
      chartScreenWidth:
        typeof window !== "undefined" ? window.innerWidth : 1920,
      tblHeaderActiveIEports: "1",
      filterOptions: {
        date: [],
        destination: [],
        origin: []
      },
      selectedFilters: {
        date: '',
        destination: '',
        origin: ''
      },
      showHeaderDateDropdown: false,
      showHeaderDestinationDropdown: false,
      showHeaderOriginDropdown: false,

      DetailCompanyShow:true,
      importDetailCompanyDetailsiD:null, 
    };
  },
  computed: {
    options() {
      return [
        {
          value: "1",
          label: this.$t("ImportExport.Imports"),
        },
        {
          value: "2",
          label: this.$t("ImportExport.Exports"),
        },
      ];
    },
    Centeroptions() {
      return [
        {
          value: "Shipments",
          label: this.$t("ImportExport.Shipments2"),
        },
        {
          value: "value",
          label: this.$t("ImportExport.value2"),
        },
      ];
    },
    tableColumnWidth() {
      const w = this.chartScreenWidth;
      if (w <= 1439)
        return {
          colum1: 40,
          colum2: 150,
          colum3: 150,
          colum4: 148,
          colum5: 148,
          colum6: 148,
        };
      if (w <= 1920)
        return {
          colum1: 60,
          colum2: 200,
          colum3: 200,
          colum4: 166,
          colum5: 166,
          colum6: 166,
        };
      return {
        colum1: 60,
        colum2: 200,
        colum3: 200,
        colum4: 220,
        colum5: 220,
        colum6: 220,
      };
    },
    topSupplyChainEchart() {
      const w = this.chartScreenWidth;
      if (w <= 1439) return { left: 12, right: 12, bottom: 12 };
      if (w <= 1920) return { left: 15, right: 15, bottom: 15 };
      return { left: 20, right: 20, bottom: 20 };
    },
    topSupplyChainEchart() {
      const w = this.chartScreenWidth;
      if (w <= 1439) return { left: 12, right: 12, bottom: 12 };
      if (w <= 1920) return { left: 15, right: 15, bottom: 15 };
      return { left: 20, right: 20, bottom: 20 };
    },
    chartLegendConfig() {
      const w = this.chartScreenWidth;
      if (w <= 1439) {
        return {
          grid: { left: 2, right: 12, top: 54 },
          legend: {
            right: 12,
            itemWidth: 26,
            itemHeight: 14,
            itemGap: 26,
            fontSize: 12,
            lineHeight: 14,
          },
          series: { barWidth: 12 },
        };
      }
      if (w <= 1920) {
        return {
          grid: { left: 2, right: 16, top: 60 },
          legend: {
            right: 15,
            itemWidth: 30,
            itemHeight: 16,
            itemGap: 30,
            fontSize: 16,
            lineHeight: 16,
          },
          series: { barWidth: 15 },
        };
      }
      return {
        grid: { left: 2, right: 20, top: 80 },
        legend: {
          right: 20,
          itemWidth: 40,
          itemHeight: 20,
          itemGap: 40,
          fontSize: 16,
          lineHeight: 18,
        },
        series: { barWidth: 20 },
      };
    },
  },
  methods: {
    
    toggleHeaderDropdown(type) {
      this[`showHeader${type}Dropdown`] = true;
    },
    getFilterOptions() {
      const isImport = this.importsandexports === "1";
      searchFilterConditions({
        import_aaaid: isImport ? this.$route.query.id3a : '',
        export_aaaid: isImport ? '' : this.$route.query.id3a,
        importOrExportType: isImport ? 3 : 5,
        hscode : this.SearchHscode,
        partnerCountryCode : this.importsandexports == "1" 
                             ? (this.selectedFilters.origin == '-1' ? '' : this.selectedFilters.origin)
                             : (this.selectedFilters.destination == '-1' ? '' : this.selectedFilters.destination),
        startTime : this.selectedFilters.date == '-1' ? '' : this.selectedFilters.date,
      }).then(res => {
        if (res.code == 200) {
          this.filterOptions.date = res.data.timePeriodList.sort((a, b) => b.code.localeCompare(a.code));;
          this.filterOptions.destination = res.data.destinationCountryList.sort((a, b) => a.valueEn.localeCompare(b.valueEn, 'en'));
          this.filterOptions.origin = res.data.sourceCountryList.sort((a, b) => a.valueEn.localeCompare(b.valueEn, 'en'));
        }
      });
    },
    resetFilterOptions(){
      this.isshowSearchHscode = false;
      this.showHeaderDateDropdown = false;
      this.showHeaderDestinationDropdown = false;
      this.showHeaderOriginDropdown = false;
      this.SearchHscode = '';
      this.selectedFilters.date = '';
      this.selectedFilters.destination = '';
      this.selectedFilters.origin = '';
    },
    // 后面需要动态改变图形
    //    resizeFn () {
    // if(this.CreditScore){
    //     this.renderChart()
    //     }
    // },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getImportExportTransactionList();
    },
    clickOutSide1() {
      if (this.$refs.upSelect1) {
        this.$refs.upSelect1.visible = false;
      }
    },
    clickOutSide2() {
      if (this.$refs.upSelect2) {
        this.$refs.upSelect2.visible = false;
      }
    },
    clickOutSide3() {
      if (this.$refs.upSelect3) {
        this.$refs.upSelect3.visible = false;
      }
    },
    clickOutSide5() {
      if (this.$refs.upSelect5) {
        this.$refs.upSelect5.visible = false;
      }
    },
    clickOutSide4() {
      if (this.$refs.upSelect4) {
        this.$refs.upSelect4.visible = false;
      }
    },
    getPartPrivilege() {
      getPartPrivilege({
        moduleId: this.$route.query.idpower,
      }).then((res) => {
        this.powerArr[0] = res.data.filter((item) => item.id == "431")[0];
        this.powerArr[1] = res.data.filter((item) => item.id == "432")[0];
        this.powerArr[2] = res.data.filter((item) => item.id == "432")[0];
        this.powerArr[3] = res.data.filter((item) => item.id == "434")[0];
      });
    },
    // 上方统计图切换
    handleCommandone(command) {
      this.selectcouny = command;
      this.ceckIEports(this.activeIEports);
    },
    // 切换洲和国家
    handleCommand(command, scope) {
      this.selectcouny = command;
      if (command == "Proportion of host country") {
        if (this.activeIEports == "Imports") {
          this.tableData = this.topImportCountriesList;
          getImportOrExportTradeByContinent({
            aaaId: this.$route.query.id3a,
            type: 1,
            market: scope.code,
          }).then((res) => {
            this.tableData = res.data.topImportCountriesList;
          });
        } else {
          this.tableData = this.topExportCountriesList;
        }
      } else {
        if (this.activeIEports == "Imports") {
          this.tableData = this.topImportCountriesList;
        } else {
          this.tableData = this.topExportCountriesList;
        }
      }
    },
    centerEcharts(value) {
      this.value2 = value;
      showImportorExportForSCRanks({
        dimension: this.value2,
        aaaId: this.$route.query.id3a,
      }).then((res) => {
        this.TopCustomers = res.data.importSupplierList;
        this.imporetvalue = res.data.importSupplierList[0].code;
        this.TopSuppliers = res.data.exportSupplierList;
        this.exportvalue = res.data.exportSupplierList[0].code;
        this.importTrendListEcharts = res.data.importTrendList;
        this.importGrowthRateTrendList = res.data.importGrowthRateTrendList;
        this.exportTrendListEcharts = res.data.exportTrendList;
        this.exportGrowthRateTrendList = res.data.exportGrowthRateTrendList;
      });
    },
    ChangesTrade(value) {
      this.value = value;
      if (this.value == 1) {
        this.ceckIEports("Imports");
      } else {
        this.ceckIEports("Exports");
      }
    },
    // 柱状图更新select
    Centeroptionschange(value) {
      getImportorExportRankBySC({
        aaaId: this.$route.query.id3a,
        dimension: this.value2,
        type: value,
        supplierId: value == 1 ? this.imporetvalue : "",
        buyerId: value == 2 ? this.exportvalue : "",
      }).then((res) => {
        if (res.code == 200) {
          if (value == 1) {
            this.importTrendListEcharts = res.data.importTrendList;
            this.importGrowthRateTrendList = res.data.importGrowthRateTrendList;
          } else {
            this.exportTrendListEcharts = res.data.exportTrendList;
            this.exportGrowthRateTrendList = res.data.exportGrowthRateTrendList;
          }
          let that = this;
          this.$nextTick(() => {
            // 在 DOM 更新后执行代码
            that.ImportExportEcharttwo();
          });
        }
      });
    },
    // 获取所有数据
    getImportExportALl() {
      getImportExportALl({
        id3a: this.$route.query.id3a,
        companyName: "",
      }).then((res) => {
        if (res.code == 200) {
          this.sixColumns = res.data.sixColumns;
          this.TopCustomers = res.data.importSupplierList;
          this.imporetvalue = res.data.importSupplierList[0]?.code;
          this.TopSuppliers = res.data.exportSupplierList;
          this.exportvalue = res.data.exportSupplierList[0]?.code;
          this.tableData = res.data.topImportCountriesList;

          this.topExportContinentList = res.data.topExportCountriesList;
          this.topExportCountriesList = res.data.topExportCountriesList;
          this.topImportContinentList = res.data.topImportCountriesList;
          this.topImportCountriesList = res.data.topImportCountriesList;
          this.importGrowthRateTrendList =
            res.data.importGrowthRateTrendList == null
              ? []
              : res.data.importGrowthRateTrendList;
          this.exportGrowthRateTrendList =
            res.data.exportGrowthRateTrendList == null
              ? []
              : res.data.exportGrowthRateTrendList;
          this.importTrendListEcharts =
            res.data.importTrendList == null ? [] : res.data.importTrendList;
          this.exportTrendListEcharts =
            res.data.exportTrendList == null ? [] : res.data.exportTrendList;
          // let exportTrendMap =
          this.exportTrendMap = res.data.exportTrendMap;
          this.importTrendMap = res.data.importTrendMap;
          this.importCountryTrendMap = res.data.importCountryTrendMap;
          this.exportCountryTrendMap = res.data.exportCountryTrendMap;
          this.changezhexianEchart(res.data.importCountryTrendMap);

          this.$emit("UpdatamarkTotalList", res.data.nineSquareGrid);

          // const transformedData = Object.entries(exportTrendMap).flatMap(([countryCode, entries]) =>
          //   entries.map(entry => ({
          //     ...entry,
          //     country: `${countryCode}`
          //   }))
          // );
          // const uniqueArray = []
          // transformedData.forEach(value => {
          //   if (!uniqueArray.includes(value.country)) {
          //     uniqueArray.push(value.country);
          //   }
          // });
          let that = this;

          this.$nextTick(() => {
            // 在 DOM 更新后执行代码
            // that.ImportExportEchart();
            that.ImportExportEcharttwo();
          });
        }
      });
    },
    ceckIEports(row) {
      this.activeIEports = row;
      if (row == "Imports") {
        this.value = "1";
        if (this.selectcouny == "Proportion of host country") {
          if (this.importCountryTrendMap) {
            this.changezhexianEchart(this.importCountryTrendMap);
          } else {
            let that = this;
            this.$nextTick(() => {
              // 在 DOM 更新后执行代码
              that.ImportExportEchart([]);
            });
          }
          this.tableData = this.topImportCountriesList;
        } else {
          if (this.importTrendMap) {
            this.changezhexianEchart(this.importTrendMap);
          } else {
            let that = this;
            this.$nextTick(() => {
              // 在 DOM 更新后执行代码
              that.ImportExportEchart([]);
            });
          }
          this.tableData = this.topImportContinentList;
        }
      } else {
        this.value = "2";
        if (this.selectcouny == "Proportion of host country") {
          if (this.exportCountryTrendMap) {
            this.changezhexianEchart(this.exportCountryTrendMap);
          } else {
            let that = this;
            this.$nextTick(() => {
              // 在 DOM 更新后执行代码
              that.ImportExportEchart([]);
            });
          }
          this.tableData = this.topExportCountriesList;
        } else {
          if (this.exportTrendMap) {
            this.changezhexianEchart(this.exportTrendMap);
          } else {
            let that = this;
            this.$nextTick(() => {
              // 在 DOM 更新后执行代码
              that.ImportExportEchart([]);
            });
          }
          this.tableData = this.topExportContinentList;
        }
      }
    },
    // 数据修改切换import export
    changezhexianEchart(exportTrendMap) {
      let entries = Object.entries(exportTrendMap);
      let arrlist = [];
      this.echartsSeveryear = entries[0][1]
          .filter(item => parseInt(item.code) > 2021)
          .map(item => item.code) || [];

      // echartsSeveryear
      entries.map((item) => {
        const filteredData = item[1]
          .filter(item => parseInt(item.code) > 2021)
          .map(item => item.dateCount);
        arrlist.push({
          name: item[0],
          data: filteredData, 
          type: "line",
          stack: "Total",
          areaStyle: {},
          emphasis: {
            focus: "series",
          },
          symbol: "", // 将点的样式设置为空字符串
          showSymbol: false, // 隐藏折线上的点，
          smooth: 0.5,
           tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return   formatNum(value);
                } else {
                  return "-";
                }
              },
            },
        });
      });
      arrlist.map((item, index) => {
        if (index == 0) {
          item.areaStyle = {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(18, 144, 201, 1)", // 起始颜色，这里使用蓝色
                },

                {
                  offset: 0.5,
                  color: "rgba(0, 0, 255, 0.3)", // 结束颜色，这里使用透明色
                },
                {
                  offset: 1,
                  color: "rgba(0, 0, 255, 0)", // 结束颜色，这里使用透明色
                },
              ],
            },
          };
        }
        if (index == 1) {
          item.areaStyle = {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(129, 201, 122, 1)", // 结束颜色，这里使用透明色
                },

                {
                  offset: 0.5,
                  color: "rgba(129, 201, 122, 0.5)", // 结束颜色，这里使用透明色
                },
                {
                  offset: 1,

                  color: "rgba(129, 201, 122, 0)", // 结束颜色，这里使用透明色
                },
              ],
            },
          };
        }
        if (index == 2) {
          item.areaStyle = {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(255, 118, 0, 1)", // 结束颜色，这里使用透明色
                },

                {
                  offset: 0.5,
                  color: "rgba(255, 118, 0, 0.5)", // 结束颜色，这里使用透明色
                },
                {
                  offset: 1,

                  color: "rgb(255, 118, 0,0.2)", // 结束颜色，这里使用透明色
                },
              ],
            },
          };
        }
        if (index == 3) {
          item.areaStyle = {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(242, 131, 191, 1)", // 结束颜色，这里使用透明色
                },

                {
                  offset: 0.5,
                  color: "rgba(242, 131, 191, 0.5)", // 结束颜色，这里使用透明色
                },
                {
                  offset: 1,

                  color: "rgba(142, 134, 221, 0.2)", // 结束颜色，这里使用透明色
                },
              ],
            },
          };
        }
        if (index == 4) {
          item.areaStyle = {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(18, 144, 201, 1)", // 结束颜色，这里使用透明色
                },

                {
                  offset: 0.5,
                  color: "rgba(18, 144, 201, 0.5)", // 结束颜色，这里使用透明色
                },
                {
                  offset: 1,

                  color: "rgba(18, 144, 201, 0.2)", // 结束颜色，这里使用透明色
                },
              ],
            },
          };
        }
      });
      this.echartsSever = arrlist;
      let that = this;
      this.$nextTick(() => {
        // 在 DOM 更新后执行代码
        that.ImportExportEchart(arrlist);
      });
    },
    // 上方趋势图
    ImportExportEchart(arrlist) {
      let minValue = Infinity;
      arrlist.forEach(series => {
        series.data.forEach(value => {
          if (value !== null && value < minValue && value !== 0) {
            minValue = value;
          }
        });
      });
      const yAxisMin = minValue;
      
      const tsc = this.topSupplyChainEchart;
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      const option = {
        // title: {
        //   text: "Stacked Area Chart",
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },

        grid: {
          left: tsc.left,
          right: tsc.right,
          bottom: tsc.bottom,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              show: false, // 不显示 x 轴线
            },
            axisTick: {
              show: false, // 不显示 x 轴上的间隔点
            },
            data: that.echartsSeveryear,
          },
        ],
        yAxis: [
          {
            type: "value",
            min: yAxisMin, 
              axisLabel: {
               formatter: function (value) {
                return formatNum(value); // 格式化为千分位
              },
            },
          },
        ],
        series: arrlist,
      };

      this.echartsBox.setOption(option, true);
    },
    resizeCharts() {
      this.chartScreenWidth = window.innerWidth;
      this.$nextTick(() => {
        this.echartsBox?.resize();
        this.importsBox1?.resize();
        this.importsBox2?.resize();
        if (this.echartsBox && this.echartsSever && this.echartsSever.length) {
          this.ImportExportEchart(this.echartsSever);
        }
        if (
          this.importsBox1 &&
          this.importsBox2 &&
          this.importTrendListEcharts?.length
        ) {
          this.ImportExportEcharttwo();
        }
      });
    },
    changeImportExportType(type) {
      this.tblHeaderActiveIEports = type;
      this.importsandexports = type;
      this.resetFilterOptions();
      this.getFilterOptions();
      this.onPageChangeList({ page: 1, size: this.page.pageSize });
    },
    applyFilter() {
      this.getFilterOptions();
      this.getImportExportTransactionList();
    },
    // 获取Overview of imports and exports数据
    getImportExportTransactionList() {
      getImportorExportTransaction({
        id3a: this.$route.query.id3a,
        type: this.importsandexports,
        countryCode: this.$route.query.companyCountry,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        hscode : this.SearchHscode,
        partnerCountryCode : this.importsandexports == "1" 
                             ? (this.selectedFilters.origin == '-1' ? '' : this.selectedFilters.origin)
                             : (this.selectedFilters.destination == '-1' ? '' : this.selectedFilters.destination),
        startTime : this.selectedFilters.date == '-1' ? '' : this.selectedFilters.date,
      })
        .then((res) => {
          if (res.code == 200) {
            this.ImporttableData = res.data.rows;
            this.page.total = Number(res.data?.total || 0);
          } else {
            this.ImporttableData = [];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    // 进度条百分比
    getProgress(item) {
      try {
        let tempData = (Number(item.dateCount) / Number(item.totalCount)) * 100;
        if (tempData > 0 && tempData <= 100) {
          return tempData;
        } else {
          return 0;
        }
      } catch (error) {
        return 0;
      }
    },
    // hscode查询
    searchPersonByName() {
      this.isshowSearchHscode = true;
      this.key++;
    },
   
     ShowDetailCompany(){
      this.DetailCompanyShow=true;
    },
    // 去贸易关单详情
    gotoExportDetail(Details) {

      if (this.powerArr[3]?.hasPrivilege) {
        
         this.DetailCompanyShow=false;
         this.importDetailCompanyDetailsiD=Details;

        // this.$router.push({
        //   path: "ImportDetail",
        //   query: {
        //     companyName: this.$route.query.companyName,
        //     idpower: this.$route.query.idpower,
        //     id3a: this.$route.query.id3a,
        //     companyCountry: this.$route.query.companyCountry,
        //     DetailsiD: Details,
        //   },
        // });
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    showSearchHscode(row) {},
    seachHS() {
      if (!this.SearchHscode.length > 0) {
        this.isshowSearchHscode = false;
      }
      this.key++;
    },
    // 点击获取铲平
    gotoProduct(companyName, showarr) {
      this.supplierId = companyName.code;
      getImportOrExportProductTrade({
        aaaId: this.$route.query.id3a,
        supplierId: companyName.code,
        type: "1",
        dimension: "Shipments",
      }).then((res) => {
        if (res.code == 200) {
          this.TopPortsImportProduct = res.data.items;
        }
      });
      this.ImpirtShow = showarr;
    },
    // 点击获取port
    gotoProductPorts(companyName, showarr) {
      getImportOrExportProductTrade({
        aaaId: this.$route.query.id3a,
        supplierId: this.supplierId,
        hscode: companyName,
        type: "1",
        dimension: "Shipments",
      }).then((res) => {
        if (res.code == 200) {
          this.TopPortsImportPorts = res.data.items;
          // this.TopPortsImportProduct=res.data.items
        }
      });
      this.ImpirtShow = showarr;
    },
    // export点击获取铲平
    gotoProducttwo(companyName, showarr) {
      this.supplierId = companyName.code;
      getImportOrExportProductTrade({
        aaaId: this.$route.query.id3a,
        supplierId: companyName.code,
        type: "2",
        dimension: "Shipments",
      }).then((res) => {
        if (res.code == 200) {
          this.TopPortsExportProduct = res.data.items;
        }
      });
      this.ExportShow = showarr;
    },
    // export点击获取点击获取port
    gotoProductPortstwo(companyName, showarr) {
      getImportOrExportProductTrade({
        aaaId: this.$route.query.id3a,
        supplierId: this.supplierId,
        hscode: companyName,
        type: "2",
        dimension: "Shipments",
      }).then((res) => {
        if (res.code == 200) {
          this.TopPortsExportPorts = res.data.items;
        }
      });
      this.ExportShow = showarr;
    },
    callBack() {
      if (this.ImpirtShow == "Product") {
        this.ImpirtShow = "Suppliers";
      } else if (this.ImpirtShow == "Ports") {
        this.ImpirtShow = "Product";
      }
    },
    callBacktwo() {
      if (this.ExportShow == "Product") {
        this.ExportShow = "Buyers";
      } else if (this.ExportShow == "Ports") {
        this.ExportShow = "Product";
      }
    },
    // 最上方百分比展示
    customColorMethod(percentage1, index) {
      let percentage = percentage1.replace(/%/g, "");
      if (index == 0) {
        return "#1290C9";
      } else if (index == 1) {
        return "#81C97A";
      } else if (index == 2) {
        return "#FF7600";
      } else if (index == 3) {
        return "#F283BF";
      } else if (index == 4) {
        return "#8E86DD";
      }
    },

    // 柱状图
    ImportExportEcharttwo() {
      let that = this;
      if (!this.$refs.ImportEchart || !this.$refs.ExportEchart) return;
      if (!this.importsBox1)
        this.importsBox1 = this.$echarts.init(this.$refs.ImportEchart);
      if (!this.importsBox2)
        this.importsBox2 = this.$echarts.init(this.$refs.ExportEchart);

      const cfg = this.chartLegendConfig;
      const option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: cfg.grid.left, // 设置左侧边距
          right: cfg.grid.right,
          top: cfg.grid.top,
          bottom: 0,
          containLabel: true,
        },
        legend: {
          right: cfg.legend.right,
          top: "0px",
          itemWidth: cfg.legend.itemWidth,
          itemHeight: cfg.legend.itemHeight,
          itemGap: cfg.legend.itemGap,
          textStyle: {
            fontSize: cfg.legend.fontSize,
            fontFamily: "Arial",
            color: "#1A2332",
            lineHeight: cfg.legend.lineHeight,
            textAlign: "left",
          },
        },
        xAxis: {
          type: "category",
          data: that.importTrendListEcharts.map((item) => item.value),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              // formatter: "{value} ",
              color: "#1290C9", // 这里设置颜色，比如红色
               formatter: function (value) {
                return  formatNum(value); // 格式化为千分位
              },
            },
          },
          {
            type: "value",
            position: "right",
            alignTicks: true,
            min: -100,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: "{value}%",
              color: "#FF7600", // 这里设置颜色，比如红色
            },
          },
        ],
        series: [
          {
            name: this.$t("ImportExport.ImportQuantity"),
            type: "bar",
            barWidth: cfg.series.barWidth,
            itemStyle: { color: "#1290C9" },
            emphasis: {
              itemStyle: {
                color: "#1290C9",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return   formatNum(value);
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.dateCount),
          },
          {
            name: this.$t("ImportExport.IncreaseDecreasexRate"),
            type: "line",
            barWidth: cfg.series.barWidth,
            yAxisIndex: 1,
            itemStyle: { color: "#FF7600" },
            emphasis: {
              itemStyle: {
                color: "#FF7600",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + "%";
              },
            },
            data: that.importGrowthRateTrendList.map((item) => item.value),
          },
        ],
      };
      const option2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: cfg.grid.left, // 设置左侧边距
          right: cfg.grid.right,
          top: cfg.grid.top,
          bottom: 0,
          containLabel: true,
        },
        legend: {
          right: cfg.legend.right,
          top: "0px",
          itemWidth: cfg.legend.itemWidth,
          itemHeight: cfg.legend.itemHeight,
          itemGap: cfg.legend.itemGap,
          textStyle: {
            fontSize: cfg.legend.fontSize,
            fontFamily: "Arial",
            color: "#1A2332",
            lineHeight: cfg.legend.lineHeight,
            textAlign: "left",
          },
        },
        xAxis: {
          type: "category",
          data: that.exportTrendListEcharts.map((item) => item.value),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              // formatter: "{value} ",
              color: "#1290C9", // 这里设置颜色，比如红色
               formatter: function (value) {
                return  formatNum(value); // 格式化为千分位
              },
            },
          },
          {
            type: "value",
            position: "right",
            alignTicks: true,
            min: -100,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: "{value}%",
              color: "#FF7600", // 这里设置颜色，比如红色
            },
          },
        ],
        series: [
          {
            name: this.$t("ImportExport.ExportQuantity"),
            type: "bar",
            barWidth: cfg.series.barWidth,
            itemStyle: { color: "#1290C9" },
            emphasis: {
              itemStyle: {
                color: "#1290C9",
              },
            },
             tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return  formatNum(value);
                } else {
                  return "-";
                }
              },
            },
            data: that.exportTrendListEcharts.map((item) => item.dateCount),
          },
          {
            name: this.$t("ImportExport.ImportsExportsRecords"),
            type: "line",
            barWidth: cfg.series.barWidth,
            yAxisIndex: 1,
            itemStyle: { color: "#FF7600" },
            emphasis: {
              itemStyle: {
                color: "#FF7600",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + "%";
              },
            },
            data: that.exportGrowthRateTrendList.map((item) => item.value),
          },
        ],
      };
      this.importsBox1.setOption(option1);
      this.importsBox2.setOption(option2);
    },
    setid(row, value) {
      let aaid = "";
      if (value == "Buyer") {
        aaid = row.buyerAaaid;
      } else {
        aaid = row.supplierAaaid;
      }
      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          aaid +
          "/background/snapshot?id3a=" +
          aaid +
          "&companyCountry=" +
          "" +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.getImportExportTransactionList();
    this.getImportExportALl();
    this.getPartPrivilege();
    this._resizeChartsHandler = () => {
      this.resizeCharts();
    };
    window.addEventListener("resize", this._resizeChartsHandler);
    this.getFilterOptions();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this._resizeChartsHandler);
    this.echartsBox?.dispose();
    this.importsBox1?.dispose();
    this.importsBox2?.dispose();
  },
};
</script>
<style scoped>
.filter-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.filter-select {
  width: 100%;
  height: 40px;
}

.dropdown-icon {
  position: absolute !important;
  top:4px;
  margin-left: 4px;
  font-size: 14px;
  color: #1290C9;
  font-family: element-icons !important;
  font-style: normal;
  line-height: 1;
}

.dropdown-icon:before {
    content: "\e6df";
}

.operations-head {
  font-size: 22px;
  color: #1a2332;
  text-align: left;
  font-style: normal;
  display: flex;
  justify-content: space-between;
  font-family: "Arial Bold";
}

.operations-box-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.el-dropdown-link {
  cursor: pointer;
  font-size: 16px;
  color: #1a2332;
  display: inline-block;
  width: 132px;
  /* color: #409eff; */
}

.el-icon-arrow-down {
  position: absolute !important;
  right: 9px !important;
  top: 14px;
  font-size: 16px !important;
  color: #1290c9;
}

.operations-box-left /deep/ .el-table tr {
  background: #f5f5f5;
  height: 96px;
  border-radius: 4px;
}

.operations-box-left /deep/ .el-table td.el-table__cell:first-child {
  padding-left: 20px;
}

.operations-box-left /deep/ .el-table td.el-table__cell {
  border-bottom: 10px solid #ffff;
}

.operations-box-left /deep/ .el-table td.el-table__cell .table-content {
  font-family: "Arial";
  font-size: 20px !important;
  color: #1a2332;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.operations-box-left /deep/ .el-table tr:last-child td.el-table__cell {
  border-bottom: none !important;
}

.operations-box-left /deep/ .el-table td:nth-child(3).el-table__cell .cell {
  padding-left: 0;
  padding-right: 0;
}

.operations-box-left /deep/ .el-table::before {
  content: "";
  position: absolute;
  background-color: #ffff;
  z-index: 1;
}

.operations-box-left {
  flex: 1;
  width: 0;
}

.operations-center-center {
  flex: 1;
  width: 0;
}

.table-content-color {
  color: #1290c9;
}

.perations-button-active {
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 22px;
  color: #1290c9 !important;
  font-family: 'Arial Bold' !important;
}

.perations-button {
  display: inline-block;
  min-width: 110px;
  padding: 0 !important;
  background: #e7eaed;
  color: #8497ab;
  border-radius: 22px;
  font-family: "Arial";
  font-size: 20px;
  line-height: 44px;
  text-align: center;
  font-style: normal;
}

.perations-content-left {
  display: flex;
  justify-content: space-between;
  width: 230px;
  height: 50px;
  padding: 3px;
  background: #e7eaed;
  border-radius: 22px;
}

.operations-content-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 10px;
  height: 80px;
  padding: 0 20px;
}

.operations-content-head:last-child {
  margin-bottom: 0px;
}

.operations-right-text {
  font-size: 16px;
  color: #1a2332;
}

.operations-right-head:not(:last-child) {
  margin-bottom: 11px !important;
}

.operations-right-head {
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  height: 86px;
}

.operations-box-right {
  max-width: 33%;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.operations-box-right span {
  font-family: "Arial";
  font-size: 20px;
  color: #666666;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}

.operations-box-right span:last-child {
  font-family: 'Arial Bold';
  color: #1a2332;
}

.operations-center-center {
  /* width: 60%; */
  /* margin-right: 0.7142857142857143rem; */
}

.operations-center-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.bottom-titletwo {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 26px;
  color: #1290c9;
  line-height: 27px;
  text-align: left;
  font-style: normal;
}

.operations-box-head-left {
  flex: 2;
  padding: 20px;
  margin-right: 10px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  gap: 20px;
}

.operations-box-center {
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.operations-box {
  background-color: #f5f5f5;
}

/deep/ .highlight-cell {
  background-color: #f2f5f9 !important;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.bottom-title {
  display: inline-block;
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 26px;
  color: #1290c9;
  line-height: 27px;
  text-align: left;
  font-style: normal;
}

.table_add {
  display: flex;
  justify-content: flex-start;
}

.table_add > span {
  display: flex;
  align-items: center;
}

.operations-box-center-left {
  width: 49%;
  padding: 20px;
  padding-bottom: 0rem;
  background: #f5f5f5;
  border-radius: 4px;
}

.operations-box-center-headr {
  margin-bottom: 20px;
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 30px;
  color: #1290c9;
  line-height: 34px;
  text-align: left;
  font-style: normal;
}

.TopPorts {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 20px;
  color: #1a2332;
  line-height: 23px;
  text-align: left;
  font-style: normal;
}

.Byshipments {
  margin-top: 10px;
  margin-bottom: 20px;
  font-family: "Arial";
  font-weight: normal;
  font-size: 16px;
  color: #8497ab;
  line-height: 18px;
  text-align: left;
  font-style: normal;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.line_step {
  margin-bottom: 30px;
  font-family: "Arial";
  font-size: 16px;
  line-height: 18px;
}

/* .Byshipments-table {
  height: 25rem;
} */

.Byshipments-table .line_step:last-child {
  margin-bottom: 60px;
}

.line_step .line_title {
  display: inline-block;
  width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1290c9;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
}

.blue_num {
  display: block;
  font-family: "Arial";
  color: #8497ab;
  text-align: right;
  font-style: normal;
}

.line_step /deep/.el-progress {
  margin-top: 10px;
}

.echartsimport {
  position: relative;
  top: -25px;
}

.el-select .el-input__inner {
  font-size: 16px !important;
}

.callBack {
  font-size: 16px;
  color: #1290c9;
  line-height: 20px;
  text-align: right;
  font-style: normal;
  text-decoration-line: underline;
}

/deep/ .el-select {
  position: relative;
  z-index: 9999;
}

.operations-content /deep/ .el-table td:last-child .cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* edit */
.operations-content {
  height: 100%;
}

::v-deep .el-progress-bar__innerText {
  font-family: "Arial";
  font-size: 14px;
  color: #ffffff !important;
  line-height: 16px;
  text-align: left;
  font-style: normal;
}

.IE_top_echarts {
  height: 534px;
}

.operations_center_changeBtn{
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 40px;
  margin-bottom: 25px;
}

.operations_center_changeBtn_content{
  width: 238px;
}

.operations_center_changeBtn_content_text{
  width: 116px;
}

@media screen and (max-width: 1920px) {
  .operations-head {
    font-size: 16px;
  }

  .el-dropdown-link {
    font-size: 14px;
    width: 100px;
  }

  .el-icon-arrow-down {
    right: 7px !important;
    top: 10px;
    font-size: 14px !important;
  }

  .operations-box-left /deep/ .el-table tr {
    height: 76px;
  }

  .operations-box-left /deep/ .el-table td.el-table__cell:first-child {
    padding-left: 15px;
  }

  .operations-box-left /deep/ .el-table td.el-table__cell {
    border-bottom: 7px solid #ffff;
  }

  .operations-box-left /deep/ .el-table td.el-table__cell .table-content {
    font-size: 16px !important;
    line-height: 18px;
  }

  .perations-button-active {
    border-radius: 18px;
  }

  .perations-button {
    min-width: 82px;
    font-size: 16px;
    line-height: 32px;
    border-radius: 18px;
  }

  .perations-content-left {
    width: 172px;
    height: 38px;
    border-radius: 18px;
  }

  .operations-content-head {
    margin-bottom: 7px;
    height: 60px;
    padding: 0 15px;
  }

  .operations-right-text {
    font-size: 14px;
  }

  .operations-right-head:not(:last-child) {
    margin-bottom: 8px !important;
  }

  .operations-right-head {
    height: 68px;
  }

  .operations-box-right {
    padding: 15px;
  }

  .operations-box-right span {
    font-size: 16px;
    line-height: 22px;
  }

  .operations-center-select {
    padding: 0 15px;
  }

  .bottom-titletwo {
    font-size: 20px;
    line-height: 22px;
  }

  .operations-box-head-left {
    padding: 15px;
    margin-right: 7px;
    gap: 15px;
  }

  .operations-box-center {
    padding: 15px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }

  .bottom-title {
    font-size: 20px;
    line-height: 40px;
  }

  .operations-box-center-left {
    padding: 15px;
  }

  .operations-box-center-headr {
    margin-bottom: 15px;
    font-size: 20px;
    line-height: 20px;
  }

  .TopPorts {
    font-size: 16px;
    line-height: 20px;
  }

  .Byshipments {
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 18px;
  }

  .line_step {
    margin-bottom: 22px;
    font-size: 16px;
    line-height: 18px;
  }

  .Byshipments-table .line_step:last-child {
    margin-bottom: 45px;
  }

  .line_step /deep/.el-progress {
    margin-top: 7px;
  }

  .echartsimport {
    top: -21px;
  }

  .el-select .el-input__inner {
    font-size: 14px !important;
  }

  .callBack {
    font-size: 14px;
    line-height: 16px;
  }

  ::v-deep .el-progress-bar__innerText {
    font-size: 12px;
    line-height: 14px;
  }

  .IE_top_echarts {
    height: 402px;
  }
  
  .operations_center_changeBtn{
    height: 40px;
    margin-bottom: 15px;
  }
  
  .operations_center_changeBtn_content{
    width: 218px;
  }

  .operations_center_changeBtn_content_text{
    width: 106px;
  }
}

@media screen and (max-width: 1439px) {
  .operations-head {
    font-size: 14px;
  }

  .el-dropdown-link {
    font-size: 12px;
    width: 88px;
  }

  .el-icon-arrow-down {
    right: 6px !important;
    top: 9px;
    font-size: 12px !important;
  }

  .operations-box-left /deep/ .el-table tr {
    height: 65px;
  }

  .operations-box-left /deep/ .el-table td.el-table__cell:first-child {
    padding-left: 12px;
  }

  .operations-box-left /deep/ .el-table td.el-table__cell {
    border-bottom: 6px solid #ffff;
  }

  .operations-box-left /deep/ .el-table td.el-table__cell .table-content {
    font-size: 14px !important;
    line-height: 16px;
  }

  .perations-button-active {
    border-radius: 16px;
  }

  .perations-button {
    min-width: 74px;
    font-size: 14px;
    line-height: 26px;
    border-radius: 16px;
  }

  .perations-content-left {
    width: 154px;
    height: 34px;
    border-radius: 16px;
  }

  .operations-content-head {
    margin-bottom: 6px;
    height: 54px;
    padding: 0 12px;
  }

  .operations-right-text {
    font-size: 12px;
  }

  .operations-right-head:not(:last-child) {
    margin-bottom: 8px !important;
  }

  .operations-right-head {
    height: 57px;
  }

  .operations-box-right {
    padding: 15px;
  }

  .operations-box-right span {
    font-size: 14px;
    line-height: 20px;
  }

  .operations-center-select {
    padding: 0 12px;
  }

  .bottom-titletwo {
    font-size: 18px;
    line-height: 20px;
  }

  .operations-box-head-left {
    padding: 12px;
    margin-right: 6px;
    gap: 12px;
  }

  .operations-box-center {
    padding: 12px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }

  .bottom-title {
    font-size: 18px;
    line-height: 20px;
  }

  .operations-box-center-left {
    padding: 12px;
  }

  .operations-box-center-headr {
    margin-bottom: 12px;
    font-size: 20px;
    line-height: 22px;
  }

  .TopPorts {
    font-size: 14px;
    line-height: 16px;
  }

  .Byshipments {
    margin-top: 6px;
    margin-bottom: 12px;
    font-size: 12px;
    line-height: 14px;
  }

  .line_step {
    margin-bottom: 20px;
    font-size: 12px;
    line-height: 14px;
  }

  .Byshipments-table .line_step:last-child {
    margin-bottom: 40px;
  }

  .line_step /deep/.el-progress {
    margin-top: 6px;
  }

  .echartsimport {
    top: -19px;
  }

  .el-select .el-input__inner {
    font-size: 12px !important;
  }

  .callBack {
    font-size: 12px;
    line-height: 14px;
  }

  ::v-deep .el-progress-bar__innerText {
    font-size: 12px;
    line-height: 14px;
  }

  .IE_top_echarts {
    height: 358px;
  }

  .operations_center_changeBtn{
    height: 34px;
    margin-bottom: 8px;
  }
  
  .operations_center_changeBtn_content{
    width: 182px;
  }

  .operations_center_changeBtn_content_text{
    width: 88px;
  }
}
</style>

<style>
.el-select-dropdown {
  width: auto !important;
}

.IE_root_el_select .el-input__inner {
  height: 36px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #8497ab;
  padding-right: 40px !important;
  font-family: "Arial";
  font-size: 16px !important;
  color: #1a2332;
  line-height: 18px !important;
  text-align: left;
  font-style: normal;
}

.el-select-dropdown__item {
  font-size: 16px !important;
}

.IE_first_box_select .el-input__inner {
  width: 200px;
}

.IE_second_box_top_select {
  margin-bottom: 10px;
}

.IE_second_box_top_select .el-input__inner,
.IE_third_box_top_select .el-input__inner {
  width: 430px;
}

.IE_second_box_content_select {
  max-width: calc(100% - 470px);
}

.IE_second_box_content_select .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
}

.IE_second_box {
  justify-content: center !important;
  gap: 40px;
}

.IE_bottom_box {
  padding: 30px 40px 0;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.IE_bottom_box_head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.IE_bottom_box_table {
  overflow-y: auto;
  border: none;
  border-collapse: collapse;
}

.IE_bottom_box_table thead,
.IE_bottom_box_table .el-table__cell {
  min-height: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.IE_bottom_box_table td,
.IE_bottom_box_table td.el-table__cell {
  min-height: 80px !important;
  height: 80px !important;
}

.IE_bottom_box_table .el-table__body-wrapper .el-table__row td:last-child,
.IE_bottom_box_table .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.IE_bottom_box_table::after {
  display: none !important;
}

.IE_bottom_box_table.el-table {
  overflow: hidden;
  table-layout: fixed;
}

.IE_bottom_box_table colgroup col:nth-child(1) {
  width: 8%;
  min-width: 180px;
}

.IE_bottom_box_table colgroup col:nth-child(2) {
  width: 16%;
}

.IE_bottom_box_table colgroup col:nth-child(3) {
  width: 220px;
  max-width: 220px;
}

.IE_bottom_box_table colgroup col:nth-child(4) {
  width: 10%;
}

.IE_bottom_box_table colgroup col:nth-child(5) {
  width: 10%;
  min-width: 230px;
}

.IE_bottom_box_table colgroup col:nth-child(6) {
  width: 22%;
}

.IE_bottom_box_table colgroup col:nth-child(7) {
  width: 10%;
  min-width: 180px;
}

.IE_bottom_box_table colgroup col:nth-child(8) {
  width: 10%;
  min-width: 220px;
}

.IE_bottom_box_table colgroup col:nth-child(9) {
  width: 10%;
}

.IE_bottom_box_table .el-table__body-wrapper .el-table__cell .cell {
  width: 100% !important;
}

.IE_bottom_box_table .el-table__cell:first-child > .cell {
  padding-left: 20px !important;
}

.IE_bottom_box_table
  .el-table__body-wrapper
  .el-table__cell:last-child
  > .cell {
  padding-right: 20px !important;
}

.IE_bottom_box_table
  .el-table__header-wrapper
  th.el-table__cell:nth-last-child(2)
  > .cell {
  padding-right: 20px !important;
}

.IE_bottom_box_table.el-table th.el-table__cell > .cell {
  font-family: "Arial bold";
}

.IE_bottom_box_table.el-table .cell,
.IE_bottom_box_table.el-table .cell .table-content {
  font-size: 18px !important;
  line-height: 30px;
}

.IE_bottom_box_table.el-table th .cell {
  font-size: 18px;
  line-height: 22px;
}

.IE_bottom_box_table.el-table th .cell span {
  font-family: "Arial bold";
}

.IE_bottom_box_table_tbody_icon {
  width: 32px;
  height: 34px;
}

.IE_bottom_box_table_search {
  width: 24px;
  height: 24px;
}

.IE_bottom_box_table_header_select .el-input__inner{
  width: 100%;
  height: 40px !important;
  font-size: 16px !important;
  border-radius: 10px;
}

.IE_bottom_box_table_search_input {
  display: flex;
  align-items: center;
}

.IE_bottom_box_table_search_input .el-input__inner {
  width: 200px;
  height: 40px !important;
  padding: 10px 30px 10px 10px !important;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(30, 33, 45, 0.14);
  border-radius: 10px;
  border: 1px solid #8497ab;
  box-sizing: border-box;

  font-family: "Arial";
  font-size: 18px;
  line-height: 46px !important;
  text-align: left;
  font-style: normal;
}

.IE_bottom_box_table_search_input .el-input__suffix {
  display: flex;
  align-items: center;
  height: 100%;
}

.IE_bottom_box_table_search_input .el-input__suffix-inner {
  display: flex;
  align-items: center;
  gap: 4px; 
}

@media screen and (max-width: 1920px) {
  .IE_root_el_select .el-input__inner {
    height: 36px;
    padding-right: 30px !important;
    font-size: 14px !important;
    line-height: 16px !important;
  }

  .el-select-dropdown__item {
    font-size: 14px !important;
  }

  .IE_first_box_select .el-input__inner {
    width: 150px;
  }

  .IE_second_box_top_select {
    margin-bottom: 25px;
  }

  .IE_second_box_top_select .el-input__inner,
  .IE_third_box_top_select .el-input__inner {
    width: 322px;
  }

  .IE_second_box_content_select {
    max-width: calc(100% - 390px);
  }

  .IE_second_box {
    gap: 30px;
  }

  .IE_bottom_box {
    padding: 22px 30px 0;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }

  .IE_bottom_box_head {
    margin-bottom: 15px;
  }

  .IE_bottom_box_table thead,
  .IE_bottom_box_table .el-table__cell {
    min-height: 44px !important;
    height: 44px !important;
  }

  .IE_bottom_box_table td,
  .IE_bottom_box_table td.el-table__cell {
    min-height: 50px !important;
    height: 50px !important;
  }

  .IE_bottom_box_table colgroup col:nth-child(3) {
    width: 166px;
    max-width: 166px;
  }

  .IE_bottom_box_table .el-table__cell:first-child > .cell {
    padding-left: 15px !important;
  }

  .IE_bottom_box_table
    .el-table__body-wrapper
    .el-table__cell:last-child
    > .cell {
    padding-right: 15px !important;
  }

  .IE_bottom_box_table
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 15px !important;
  }

  .IE_bottom_box_table.el-table .cell,
  .IE_bottom_box_table.el-table .cell .table-content {
    font-size: 16px !important;
    line-height: 22px;
  }

  .IE_bottom_box_table.el-table th .cell {
    font-size: 16px;
    line-height: 20px;
  }

  .IE_bottom_box_table_header_select .el-input__inner{
    height: 32px !important;
    font-size: 14px !important;
    border-radius: 7px;
  }

  .IE_bottom_box_table_tbody_icon {
    width: 24px;
    height: 24px;
  }

  .IE_bottom_box_table_search {
    width: 18px;
    height: 18px;
  }

  .IE_bottom_box_table_search_input .el-input__inner {
    width: 150px;
    height: 32px !important;
    padding: 7px 22px 7px 7px !important;
    box-shadow: 0px 2px 7px 0px rgba(30, 33, 45, 0.14);
    font-size: 16px;
    line-height: 34px !important;
    border-radius: 7px;
  }

  .IE_bottom_box_table_search_input .el-input__suffix {
    right: 6px !important;
  }
}

@media screen and (max-width: 1439px) {
  .IE_root_el_select .el-input__inner {
    height: 30px;
    padding-right: 26px !important;
    font-size: 14px !important;
    line-height: 16px !important;
  }

  .el-select-dropdown__item {
    font-size: 14px !important;
  }

  .IE_first_box_select .el-input__inner {
    width: 134px;
  }

  .IE_second_box_top_select {
    margin-bottom: 6px;
  }

  .IE_second_box_top_select .el-input__inner,
  .IE_third_box_top_select .el-input__inner {
    width: 288px;
  }

  .IE_second_box_content_select {
    max-width: calc(100% - 330px);
  }

  .IE_second_box {
    gap: 26px;
  }

  .IE_bottom_box {
    padding: 20px 26px 0;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }

  .IE_bottom_box_head {
    margin-bottom: 8px;
  }

  .IE_bottom_box_table thead,
  .IE_bottom_box_table .el-table__cell {
    min-height: 32px !important;
    height: 32px !important;
  }

  .IE_bottom_box_table td,
  .IE_bottom_box_table td.el-table__cell {
    min-height: 54px !important;
    height: 54px !important;
  }

  .IE_bottom_box_table colgroup col:nth-child(3) {
    width: 148px;
    max-width: 148px;
  }

  .IE_bottom_box_table .el-table__cell:first-child > .cell {
    padding-left: 12px !important;
  }

  .IE_bottom_box_table
    .el-table__body-wrapper
    .el-table__cell:last-child
    > .cell {
    padding-right: 12px !important;
  }

  .IE_bottom_box_table
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 12px !important;
  }

  .IE_bottom_box_table.el-table .cell,
  .IE_bottom_box_table.el-table .cell .table-content {
    font-size: 14px !important;
    line-height: 20px;
  }

  .IE_bottom_box_table.el-table th .cell {
    font-size: 14px;
    line-height: 18px;
  }

  .IE_bottom_box_table_tbody_icon {
    width: 22px;
    height: 22px;
  }

  .IE_bottom_box_table_search {
    width: 16px;
    height: 16px;
  }

  .IE_bottom_box_table_header_select .el-input__inner{
    height: 26px !important;
    font-size: 14px !important;
    border-radius: 6px;
  }

  .IE_bottom_box_table_search_input .el-input__inner {
    width: 134px;
    height: 26px !important;
    padding: 6px 20px 6px 6px !important;
    box-shadow: 0px 2px 6px 0px rgba(30, 33, 45, 0.14);
    font-size: 14px;
    line-height: 30px !important;
    border-radius: 6px;
  }

  .IE_bottom_box_table_search_input .el-input__suffix {
    right: 5px !important;
  }
}
</style>